import { StateCreator } from 'zustand';
import { waitForOT, toggleCookieBanner } from '../../helper/onetrust';
import { buildConsentSnapshot } from '../../helper/consent-snapshot';
import { ConsentFramework } from '@/features/consent/internal/models/consent';

export interface ConsentState {
  ready: boolean;
  country?: string;
  state?: string;
  framework: ConsentFramework;
  activeGroups: string[];
}
export interface ConsentActions {
  init: () => Promise<void>;
  refresh: () => void;
  toggleCookieBanner: () => Promise<void>;
}

export interface ConsentSlice {
  consent: ConsentState;
  consentActions: ConsentActions;
}

export const createConsentSlice: StateCreator<ConsentSlice> = (set) => ({
  consent: {
    ready: false,
    framework: 'Unknown',
    activeGroups: [],
  },
  consentActions: {
    init: async () => {
      await waitForOT();
      const snap = buildConsentSnapshot();
      set({ consent: snap });
    },
    refresh: () => {
      const snap = buildConsentSnapshot();
      set({ consent: snap });
    },
    toggleCookieBanner: async () => {
      await toggleCookieBanner();
    },
  },
});
